import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";

const postAuthToken = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/OAuth",
    params
  )
}

export { postAuthToken };
